import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const SquareIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        d="M14 3H6C4.34315 3 3 4.34315 3 6L3.00002 14C3.00002 15.6569 4.34316 17 6.00002 17H14C15.6569 17 17 15.6569 17 14L17 6C17 4.34314 15.6568 3 14 3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};
